import { render, staticRenderFns } from "./FeeSetting.vue?vue&type=template&id=45142688&"
import script from "./FeeSetting.vue?vue&type=script&lang=js&"
export * from "./FeeSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports